import { classNames, joinStyles, propFromName } from '../../utils'
import { BaseDataTableCheckbox, BaseDataTableRadio, BaseTd, BaseTr } from '../../base/BaseDataTable'
export default function DataTableRow({
    innerRef,
    columns,
    selectionMode,
    selectionOn,
    onKeyDown,
    value,
    rowIndex,
    rowSpan,
    rowSpanField,
    selectable,
    disabled,
    selected,
    selectableIndex,
    onSelect,
    className,
    style,
}) {
    const handleSelect = () => {
        onSelect(value, selected)
    }
    const handleEnter = (e) => {
        e.key === 'Enter' && handleSelect()
    }
    return (
        <BaseTr
            ref={selectionOn === 'row' ? innerRef : undefined}
            className={className}
            style={style}
            {...(selectable &&
                selectionOn === 'row' && {
                    tabIndex: 0,
                    onClick: handleSelect,
                    onKeyUp: handleEnter,
                    onKeyDown: (e) => onKeyDown(e, selectableIndex),
                })}
        >
            {columns.map((col, index) => {
                const field = col.field ?? ''
                if (rowSpanField && rowSpanField === field && rowSpan === 0) {
                    return null
                }
                const data = propFromName(value, field)
                return (
                    <BaseTd
                        key={col.selector ? 'selector' : (col.id ?? index)}
                        className={classNames(
                            col.className,
                            typeof col.bodyClassName === 'function'
                                ? col.bodyClassName(value, { rowIndex, disabledRow: disabled })
                                : col.bodyClassName,
                        )}
                        style={joinStyles(
                            col.style,
                            typeof col.bodyStyle === 'function'
                                ? col.bodyStyle(value, { rowIndex, disabledRow: disabled })
                                : col.bodyStyle,
                        )}
                        {...(rowSpan > 1 && rowSpanField === field && { rowSpan })}
                    >
                        {col.selector ? (
                            <div className='dtr-selector'>
                                {selectionMode === 'multiple' ? (
                                    <BaseDataTableCheckbox
                                        ref={selectionOn !== 'row' ? innerRef : undefined}
                                        disabled={disabled}
                                        checked={selected}
                                        {...(disabled || selectionOn === 'row'
                                            ? { tabIndex: -1, onChange: () => {} }
                                            : { onChange: handleSelect, onKeyUp: handleEnter })}
                                    />
                                ) : selectionMode === 'single' ? (
                                    <BaseDataTableRadio
                                        ref={selectionOn !== 'row' ? innerRef : undefined}
                                        disabled={disabled}
                                        checked={selected}
                                        {...(disabled || selectionOn === 'row'
                                            ? { tabIndex: -1, onChange: () => {} }
                                            : { onChange: handleSelect, onKeyUp: handleEnter })}
                                    />
                                ) : null}
                            </div>
                        ) : typeof col.body === 'function' ? (
                            col.body(value, { rowIndex, disabledRow: disabled })
                        ) : col.body ? (
                            col.body
                        ) : !['', null, undefined].includes(data) ? (
                            data
                        ) : typeof col.default === 'function' ? (
                            col.default(value, { rowIndex, disabledRow: disabled })
                        ) : (
                            (col.default ?? '')
                        )}
                    </BaseTd>
                )
            })}
        </BaseTr>
    )
}
